import { h } from "../core/dom.js";

// Read-only star display. value 0–5 (may be fractional); shows filled/half/empty glyphs.
export function stars(value, { size = "1rem", dim = false } = {}) {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  const glyphs = [];
  for (let i = 1; i <= 5; i++) {
    glyphs.push(v >= i ? "★" : v >= i - 0.5 ? "⯪" : "☆");
  }
  return h("span", { class: ["stars", dim && "dim"], style: { fontSize: size, letterSpacing: "1px", color: dim ? "var(--muted)" : "#f5a623" } }, glyphs.join(""));
}

// Interactive 1–5 star input. onChange(rating) fires on click. Returns an element with .setValue.
//
// IMPORTANT: the five star nodes are created once and only their text/colour is mutated
// in place. An earlier version rebuilt the children on every hover, which detached the
// node a tap was landing on — on touch devices the synthesized click was lost and the
// rating silently did nothing.
export function starInput(initial = 0, onChange) {
  let value = initial;
  const root = h("div", { class: "star-input", style: { display: "inline-flex", gap: "4px", cursor: "pointer", fontSize: "1.7rem", lineHeight: 1, touchAction: "manipulation" } });
  const spans = [];

  function paint(shown) {
    for (let i = 0; i < 5; i++) {
      const on = i + 1 <= shown;
      spans[i].textContent = on ? "★" : "☆";
      spans[i].style.color = on ? "#f5a623" : "var(--border)";
    }
  }

  for (let i = 1; i <= 5; i++) {
    const span = h("span", {
      role: "button",
      "aria-label": `${i} star${i === 1 ? "" : "s"}`,
      onClick: () => { value = i; paint(value); onChange?.(i); },
      onMouseenter: () => paint(i),
      onMouseleave: () => paint(value),
    }, "☆");
    spans.push(span);
    root.appendChild(span);
  }

  paint(value);
  root.setValue = (v) => { value = v; paint(value); };
  return root;
}
